export default function Terms() {
  return (
    <section className="grain relative bg-black px-6 pb-32 pt-40">
      <div className="container-x max-w-3xl">
        <p className="label mb-6 inline-flex items-center gap-3">
          <span className="h-px w-10 bg-gold" />
          Terms
        </p>
        <h1 className="font-display text-section font-light text-white">
          Terms of Use
        </h1>
        <p className="mt-4 font-sans text-caption text-stone">
          Samia Systems Limited · United Kingdom
        </p>

        <div className="mt-12 flex flex-col gap-6 font-sans text-body text-white/85">
          <p>
            This website is provided by Samia Systems Limited for informational
            purposes. Nothing on this website constitutes a binding offer or a
            professional engagement. Engagements begin with a written
            Diagnostic agreement.
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            Library documents
          </h2>
          <p>
            Documents downloaded from the Library are sample artefacts provided
            for reference. They are anonymised and may not reflect the
            specifics of any active client engagement. They remain the
            intellectual property of Samia Systems Limited and may not be
            reproduced for commercial use without permission.
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            Liability
          </h2>
          <p>
            We make reasonable effort to keep this site accurate and available.
            We do not warrant uninterrupted access. To the maximum extent
            permitted by law, we accept no liability for indirect or
            consequential loss arising from your use of this site.
          </p>

          <h2 className="font-display text-2xl font-light text-white">
            Governing law
          </h2>
          <p>
            These terms are governed by the laws of England and Wales.
          </p>
        </div>
      </div>
    </section>
  );
}
